export default __webpack_public_path__ + "static/media/037-temperature reader.4afe450c.svg";